function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", null, ".trophy_svg__st0{fill:#010101}");
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "trophy_svg__st0",
  d: "M157.4 242.9c-1.6-4 8.1-7.7 8.9-18.6.8-10.9-6.5-15.4-6.5-23.1 0-7.7 36.4-15.4 55-74.1 18.6-58.7 10.5-89.5 6.9-94.7-3.6-5.3-27.7-12.1-77.1-12.1-49.4 0-73.5 6.9-77.1 12.1-3.6 5.3-11.7 36 6.9 94.7s55 66.4 55 74.1c0 7.7-7.3 12.1-6.5 23.1s10.5 14.6 8.9 18.6-22.7 14.2-26.3 20.2c-3.6 6.1-2 13 8.1 13h62c10.1 0 11.7-6.9 8.1-13-3.6-6.1-24.7-16.2-26.3-20.2z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "trophy_svg__st0",
  d: "M280.1 59.9c-6.4-17.5-29.2-22.1-46.4-22.9 1.5 5.9 2.6 14.1 2.6 24.6.7.1 1.4.1 2.2.2 13.6 1.5 18.1 5 18.7 6.4 1.5 6.9-6.5 36.3-28.4 60.9-2 2.3-4.3 4.6-6.8 7-6.8 19-15.5 32.8-24 42.9 20.5-7.2 39-20.8 54.3-40.2 21.1-26.6 33.8-62.7 27.8-78.9zM60.1 129c-21.8-24.6-29.9-54-28.4-60.9.7-1.4 5.1-4.9 18.7-6.4.7-.1 1.5-.1 2.2-.2 0-10.5 1.1-18.7 2.6-24.6-17.2.8-40 5.4-46.4 22.9-5.9 16.2 6.7 52.3 27.7 78.8 15.3 19.4 33.8 32.9 54.3 40.2-8.5-10.1-17.2-23.8-24-42.9-2.4-2.2-4.6-4.6-6.7-6.9z"
});
function SvgTrophy(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trophy_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 288 288",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
export default __webpack_public_path__ + "980f4d255baf2a78721b0647e8333af8.svg";
export { SvgTrophy as ReactComponent };